var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "game-history-item",
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _c("div", { staticClass: "table__cell game-history-item__cell-id" }, [
        _vm.isLg
          ? _c("span", { staticClass: "game-history-item__mob-title" }, [
              _vm._v("局号 ID"),
            ])
          : _vm._e(),
        _c("div", { staticClass: "wheel-round__id" }, [
          _vm._v("#" + _vm._s(_vm.id)),
        ]),
      ]),
      _c("div", { staticClass: "table__cell" }, [
        _vm.isLg
          ? _c("span", { staticClass: "game-history-item__mob-title" }, [
              _vm._v("时间"),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "wheel-round__time" },
          [
            !_vm.isLg
              ? [_vm._v(" " + _vm._s(_vm.endAt) + " ")]
              : [_vm._v(" " + _vm._s(_vm._f("formatTime")(_vm.endAt)) + " ")],
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "table__cell game-history-item__cell-bank" }, [
        _vm.isLg
          ? _c("span", { staticClass: "game-history-item__mob-title" }, [
              _vm._v("底池"),
            ])
          : _vm._e(),
        _c("div", { staticClass: "wheel-round__bank" }, [
          _c("i", { staticClass: "icon icon_coin-bold" }),
          _c("div", { staticClass: "wheel-round__value" }, [
            _c("span", [_vm._v(_vm._s(_vm.formattedBank))]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "table__cell game-history-item__cell-players" },
        [
          _vm.isLg
            ? _c("span", { staticClass: "game-history-item__mob-title" }, [
                _vm._v("玩家"),
              ])
            : _vm._e(),
          _c("div", { staticClass: "wheel-round__players" }, [
            _c("i", { staticClass: "icon icon_users-bold" }),
            _vm._v(" " + _vm._s(_vm.formattedUsersCount) + " "),
          ]),
        ]
      ),
      _c("div", { staticClass: "table__cell" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }